import { useEffect, useRef, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { usePlatform } from "@/context/PlatformContext";
import { JasrMark } from "@/components/JasrLogo";
import {
  Zap, BarChart2, GitBranch, RefreshCw,
  FileSpreadsheet, ShoppingBag, ArrowLeft, CheckCircle2,
  TrendingUp, Shield, Database, Sun, Moon, Menu, X as XIcon, Upload,
  LayoutDashboard, GitCompare, Package, ScrollText, Settings,
  Star, Check, Users, Clock, Award, ChevronLeft,
} from "lucide-react";

/* ── Official brand logos (embedded) ── */
const SALLA_LOGO = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjM4IiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIzOCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIzNi45NCAxNDIuMDYzTDIyNS4zNzIgNDUuNjI4NEMyMjIuMjYgMTkuNjY0NyAyMDAuMTkgMC4wNzg1NTIyIDE3NC4wMzYgMC4wNzg1NTIySDYzLjU1QzM3LjM5NTkgMC4wNzg1NTIyIDE1LjMyNjQgMTkuNjY0NyAxMi4yMTQ2IDQ1LjYyODRMMC42NTg3MjkgMTQyLjA2M0MtMS4wOTk1OCAxNTYuNzMxIDMuNTEwNyAxNzEuNDgzIDEzLjMyMDQgMTgyLjUzMkMyMy4xMTggMTkzLjU4OSAzNy4yMTc2IDE5OS45MjEgNTEuOTk0MSAxOTkuOTIxSDE4NS42MDRDMjAwLjM2OSAxOTkuOTIxIDIxNC40NjggMTkzLjU4OSAyMjQuMjc4IDE4Mi41MzJDMjM0LjA3NiAxNzEuNDg2IDIzOC42OTggMTU2LjczNCAyMzYuOTQgMTQyLjA2M1pNMjA1LjI1MSAxNjUuNzczQzIwMCAxNzEuNjg5IDE5Mi43NTUgMTc0Ljk0MyAxODQuODU4IDE3NC45NDNINTIuNzQzM0M0NC44MzQgMTc0Ljk0MyAzNy41ODYyIDE3MS42ODkgMzIuMzUwNiAxNjUuNzczQzI3LjA5OTggMTU5Ljg1OCAyNC43MzczIDE1Mi4yODEgMjUuNjczOCAxNDQuNDI5TDM3LjA5OTggNDkuMDc1NUMzOC43NDAzIDM1LjM5MjggNTAuMzc3OCAyNS4wNTc0IDY0LjE2OTMgMjUuMDU3NEgxNzMuNDJDMTg3LjIwOSAyNS4wNTc0IDE5OC44NDkgMzUuMzg5NyAyMDAuNDkgNDkuMDc1NUwyMTEuOTI4IDE0NC40MjlDMjEyLjg2NCAxNTIuMjgxIDIxMC40ODcgMTU5Ljg1OCAyMDUuMjUxIDE2NS43NzNaIiBmaWxsPSJ3aGl0ZSIvPjxwYXRoIGQ9Ik0xODUuMTc4IDExMi40NjJDMTgzLjM1OSAxMDkuNjc0IDE4MC41NjUgMTA3Ljc2MSAxNzcuMzA4IDEwNy4wNzZDMTc0LjA0NSAxMDYuMzkgMTcwLjcyMiAxMDcuMDE1IDE2Ny45MzMgMTA4LjgzMUMxMzQuNjY4IDEzMC41MjYgMTAyLjI5MyAxMzAuNTIzIDY4Ljk2MzYgMTA4LjgyOEM2Ni4xNzUxIDEwNy4wMTIgNjIuODQyOCAxMDYuMzg3IDU5LjU4OSAxMDcuMDc5QzU2LjMzMjIgMTA3Ljc2NyA1My41NDA3IDEwOS42ODMgNTEuNzI1IDExMi40NzFDNDkuOTA5MyAxMTUuMjYgNDkuMjg2OSAxMTguNTg5IDQ5Ljk3NTcgMTIxLjg0NkM1MC42NjQ1IDEyNS4xMDMgNTIuNTggMTI3Ljg5NCA1NS4zNjg1IDEyOS43MUM3Ni4xOTYzIDE0My4yNjkgOTcuNDI4OSAxNTAuMTQyIDExOC40NzcgMTUwLjE0MkMxMzkuNTI5IDE1MC4xNDIgMTYwLjc0NiAxNDMuMjY2IDE4MS41NDQgMTI5LjcwNEMxODQuMzMyIDEyNy44ODUgMTg2LjI0NSAxMjUuMDkxIDE4Ni45MyAxMjEuODM0QzE4Ny42MTkgMTE4LjU4IDE4Ni45OTcgMTE1LjI1MSAxODUuMTc4IDExMi40NjJaIiBmaWxsPSJ3aGl0ZSIvPjwvc3ZnPg==";
const QOYOD_LOGO = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAKlBMVEVHcEwDBw0UI10VJF8VJF8VJF4VJF8VJF9I1/ZG0e9I1/ZH1vUVJF9I1/YU/V41AAAADHRSTlMAAivivVRxmdAksWQskAjnAAAEuklEQVR4nO1b2ZbkIAgli1rL9P//7miWSox4QWMqfc4MT92pRK6AgILU6YmIuq7vjbXOjQs5Z03f9+E3KhhqN6ieOfXG8x3+pDQMo7OVIFRf+HE9c451BGOcQLQHME1d4r6Qx1AIQXo7SF7LfcFgijQhvEqdGUu4z1QiBvgiUQ17T4NTQwCv1c1+hWCVCyz/FvX17GcIKiHk3iGyRabHkddDNYCz01/IyHpgX/DGd3r6Mzl5nbPPXBv2ngZJDezPTcS/IjAYQfprI/VvZOBqSH/rG6l/I1siAWrP3yOA7u7q+U8ItAAumf+EICuDww+N7W+j7Fqg6O/L+Of9QfTYXsbfI8j4xN1TMhfy95mSBKDAAEMSbK2Z83P1V7wh7gDoDGBwpp+zdFo3Clb5JWsGn2ekMgBnukPKOf2nwzByZrA+UinA5fL+kLkrvueU8HkkR2CUaAaNyCkUpwRaBSB+jIPaNIY4CZeXgKTDUZHfUScKIR1lfiC6ADm1WoQgIEidAakEoE3y5WiaiIA0AkDxPBkPz2VkJSD4IJjRFMogWQjhX2EJuLINt2AHjgMAlw/rvyBhhR5zIAmymNgzMoATMikAGAWEtJ4nZFNjAqDkdSUhJRxESoIJlisgDAqXlT0CQHAZ561CgMwqdgWE42CVAAKBQWMd+DUOwB4XbRsRRHZNHTKBagFA5+piCYBFWO6DtnGBZQ2xBIC2CoJQSkAH0WYAeIEKJ7gjMLG9ESBrSUJnCSEd2AhA/r3qNSDNbD8wAloVBjbK63YvWrQI6tfANHLeCPYZLgqdZ9h3KCLtrRs4jLpAuI2cty4lgFM2GCgv2511Ud5WT7mhMPTdAIAv3ANQwawiMLfbAdjvAMjb95cA/GIVfGkZ3g5AJdzrPCEBT/irYgGIhidVoIyGt+QD+wPa2zOi23NC8F7uiF8HQJsVX7UvQNYd7Qtu3xndvze8e3cMZVXtDOG5z+F8AJ7nfOGE5KIzIjDm8YzoglMyLNXjKdkF54RwTsk5oXC2WxEQ8NlvelJ6+1lx69NyofyRnpbfXy8QKyYlAKS6FVcxaVozEvgnjkVZNVM350k9QHzVTKqyfKFuKNbuVZVTuXycq5wquifE2jEpWtDytWNN/xpu01QUjlH1XNs/wDfMhuK9pv0T9g+IdjjRaJIehoCpV7VfsoFNtUvc07A2ca/UmzY9JMVdNMaTdePQrIvm9j4iKSqepFxYV5dvLuIfe9jm3ZwbqbrpigyxjLT9hHQRAhDPk+goNhRV0JoFUUwsgCu0YFdWz4hml8pEh/Z9xTP79+sR0ev9JA5Ad01n9fPxk9DjTZlEp11v57L+iePv6Z2L8K288ueKwYvl//N45vxTE0P4ZFH05vkHEWQAaBIc9fQ7ygjAiwB4iLN3TPZJZBbADwBQfclnYh834NUACBi62qsex/stlQC6uqtOQ3rTqhrAdI5XeteMSd9PAJg1oeyfHqbJM2OeA9DNN/4kEEu+zA5wFsB8mTIk4DyIITBHtx1PA/igmGC46M6pNctGAXzaBsAORwxKHqQpgBr6D+CfB1AVjpsCeOYA5BKS5lSakrWmXFL6rLwyX4OAkUGY/7cAhH1RvDN5vd6B+1+7vo5XxRKiZAAAAABJRU5ErkJggg==";

/* ─── dark mode hook ─── */
function useDarkMode() {
  const [dark, setDark] = useState(() => {
    try {
      const stored = localStorage.getItem("jasr-dark");
      if (stored !== null) return stored === "1";
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    } catch { return false; }
  });
  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    try { localStorage.setItem("jasr-dark", dark ? "1" : "0"); } catch {}
  }, [dark]);
  return [dark, setDark];
}

/* ─── scroll reveal hook ─── */
function useReveal(threshold = 0.1) {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVis(true); obs.disconnect(); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, vis];
}

/* ─── animated counter ─── */
function Counter({ to, suffix = "", prefix = "" }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      obs.disconnect();
      let s = 0; const step = Math.ceil(to / 55);
      const t = setInterval(() => {
        s = Math.min(s + step, to); setVal(s);
        if (s >= to) clearInterval(t);
      }, 18);
    }, { threshold: 0.4 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [to]);
  return <span ref={ref}>{prefix}{val.toLocaleString("en-US")}{suffix}</span>;
}

/* ─── brand logo ─── */
function BrandLogo({ domain, name, size = 40 }) {
  const [err, setErr] = useState(false);
  if (err) return (
    <div style={{ width: size, height: size }}
      className="rounded-lg bg-slate-200 dark:bg-slate-700 flex items-center justify-center text-xs font-bold text-slate-500">
      {name[0]}
    </div>
  );
  return (
    <img
      src={`https://www.google.com/s2/favicons?domain=${domain}&sz=128`}
      alt={name} width={size} height={size}
      className="rounded-lg object-contain"
      onError={() => setErr(true)}
    />
  );
}

/* ─── SyncBridge ─── */
function SyncBridge({ dark }) {
  const [pos, setPos] = useState(0);
  const [burst, setBurst] = useState(false);
  useEffect(() => {
    let frame; let start = null; const dur = 1800;
    const tick = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / dur, 1);
      setPos(p);
      if (p >= 1) {
        setBurst(true);
        setTimeout(() => { setBurst(false); start = null; setPos(0); }, 400);
      } else { setBurst(false); }
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, []);
  const e = pos < 0.5 ? 2 * pos * pos : 1 - Math.pow(-2 * pos + 2, 2) / 2;
  const pathColor = dark ? "#334155" : "#CBD5E1";
  return (
    <div className="relative w-full max-w-xl mx-auto select-none" style={{ height: 170 }}>
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 170" fill="none" preserveAspectRatio="none">
        <path id="bridgePath" d="M 345 95 Q 200 20 55 95" stroke={pathColor} strokeWidth="2" strokeDasharray="6 4" fill="none" />
        {e > 0.02 && e < 0.97 && (
          <>
            <circle r="14" fill="rgba(0,78,235,0.10)">
              <animateMotion dur="0.01s" fill="freeze" keyPoints={`${e};${e}`} keyTimes="0;1" calcMode="linear">
                <mpath href="#bridgePath" />
              </animateMotion>
            </circle>
            <circle r="5.5" fill="#004EEB">
              <animateMotion dur="0.01s" fill="freeze" keyPoints={`${e};${e}`} keyTimes="0;1" calcMode="linear">
                <mpath href="#bridgePath" />
              </animateMotion>
              <animate attributeName="r" values="5;7.5;5" dur="0.7s" repeatCount="indefinite" />
            </circle>
          </>
        )}
        {burst && (
          <circle cx="345" cy="95" r="7" fill="#10B981">
            <animate attributeName="r" values="7;26" dur="0.4s" fill="freeze" />
            <animate attributeName="opacity" values="1;0" dur="0.4s" fill="freeze" />
          </circle>
        )}
      </svg>
      <div className="absolute flex flex-col items-center gap-2" style={{ right: "4%", top: "28%" }}>
        <div className={`w-16 h-16 rounded-2xl border-2 flex items-center justify-center shadow-md overflow-hidden
          ${dark ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`}>
          <img src={QOYOD_LOGO} alt="قيود" className="w-10 h-10 object-contain" />
        </div>
        <span className={`text-xs font-bold tracking-wide ${dark ? "text-slate-400" : "text-slate-500"}`}>قيود</span>
      </div>
      <div className="absolute flex flex-col items-center gap-2" style={{ left: "4%", top: "28%" }}>
        <div className="w-16 h-16 rounded-2xl bg-[#004956] border-2 border-[#003a44] flex items-center justify-center shadow-md shadow-teal-900/20 overflow-hidden">
          <img src={SALLA_LOGO} alt="سلة" className="w-9 h-9 object-contain" />
        </div>
        <span className="text-xs font-bold tracking-wide text-[#004956]">سلة</span>
      </div>
    </div>
  );
}

/* ─── Dashboard Mockup ─── */
const SPARKLINES = {
  products:  [[0,22],[8,20],[16,17],[24,18],[32,14],[40,12],[48,10],[56,11],[64,8]],
  inventory: [[0,18],[8,15],[16,19],[24,14],[32,16],[40,11],[48,13],[56,10],[64,12]],
  success:   [[0,20],[8,19],[16,20],[24,18],[32,19],[40,20],[48,19],[56,20],[64,20]],
  failed:    [[0,8],[8,10],[16,14],[24,18],[32,16],[40,14],[48,12],[56,10],[64,8]],
  lowstock:  [[0,14],[8,13],[16,15],[24,13],[32,14],[40,12],[48,14],[56,12],[64,11]],
  branches:  [[0,20],[8,20],[16,20],[24,20],[32,20],[40,20],[48,20],[56,20],[64,20]],
};

function Spark({ points, color }) {
  const w = 64, h = 24;
  const d = points.map((p, i) => `${i === 0 ? "M" : "L"}${p[0]},${p[1]}`).join(" ");
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} fill="none" className="opacity-70">
      <path d={d} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d={`${d} L${w},${h} L0,${h} Z`} fill={color} fillOpacity="0.08" />
    </svg>
  );
}

function DashboardMockup() {
  const [progress, setProgress] = useState(62);
  const [pulse, setPulse] = useState(false);
  const [activeNav, setActiveNav] = useState(0);
  const [animating, setAnimating] = useState(false);
  const { name: platformName, logo_base64 } = usePlatform();

  useEffect(() => {
    const t = setInterval(() => {
      setProgress(p => {
        const next = p + 0.4;
        if (next >= 100) { setPulse(true); setTimeout(() => setPulse(false), 600); return 12; }
        return next;
      });
    }, 80);
    return () => clearInterval(t);
  }, []);

  const handleNavClick = (i) => {
    if (i === activeNav) return;
    setAnimating(true);
    setTimeout(() => { setActiveNav(i); setAnimating(false); }, 180);
  };

  const NAV = ["لوحة التحكم","مطابقة المنتجات","استيراد Excel","المنتجات","الفروع","سجل التزامن","الإعدادات"];
  const NAV_PAGES = ["dashboard","matching","excel","products","branches","synclog","settings"];
  const NAV_ICONS = [LayoutDashboard, GitCompare, Upload, Package, GitBranch, ScrollText, Settings];

  const STATS = [
    { label: "إجمالي المنتجات", val: "16,279", sub: "+2.4% هذا الشهر",   color: "#3B82F6", bg: "rgba(59,130,246,0.08)",  spark: "products"  },
    { label: "إجمالي المخزون",  val: "12,459", sub: "عبر جميع الفروع",   color: "#10B981", bg: "rgba(16,185,129,0.08)", spark: "inventory" },
    { label: "معدل النجاح",     val: "98.2%",  sub: "آخر 30 عملية",     color: "#A78BFA", bg: "rgba(167,139,250,0.08)", spark: "success"   },
    { label: "فشل التزامن",     val: "3",      sub: "تحتاج مراجعة",      color: "#F87171", bg: "rgba(248,113,113,0.08)", spark: "failed"    },
    { label: "مخزون منخفض",    val: "15",     sub: "دون الحد الأدنى",   color: "#FBBF24", bg: "rgba(251,191,36,0.08)",  spark: "lowstock"  },
    { label: "فروع نشطة",      val: "4 / 4",  sub: "جميعها مفعّلة",      color: "#34D399", bg: "rgba(52,211,153,0.08)", spark: "branches"  },
  ];
  const LOG = [
    { time: "02:15", label: "مزامنة تلقائية", status: "ناجحة",      color: "#10B981", tag: "bg-emerald-500/10 text-emerald-400" },
    { time: "01:58", label: "تحديث مخزون",    status: "ناجحة",      color: "#10B981", tag: "bg-emerald-500/10 text-emerald-400" },
    { time: "01:23", label: "ربط منتجات",     status: "قيد التنفيذ", color: "#3B82F6", tag: "bg-blue-500/10 text-blue-400" },
    { time: "00:47", label: "مزامنة تلقائية", status: "فشل",        color: "#F87171", tag: "bg-red-500/10 text-red-400" },
  ];

  const ViewDashboard = (
    <div className="flex-1 p-3 min-w-0 overflow-hidden">
      <div className="rounded-xl p-3 mb-3 flex items-start justify-between gap-3"
        style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div>
          <div className="text-sm font-bold text-white">مركز التحكم</div>
          <div className="text-[10px] mt-0.5" style={{ color:"rgba(148,163,184,0.6)" }}>متابعة لحظية · آخر تزامن قبل 3 دقائق</div>
        </div>
        <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold shrink-0"
          style={{ background:"rgba(16,185,129,0.12)", border:"1px solid rgba(16,185,129,0.2)", color:"#10B981" }}>
          <span className={`w-1.5 h-1.5 rounded-full bg-emerald-400 ${pulse?"":"animate-pulse"}`}/>مباشر
        </div>
      </div>
      <div className="rounded-xl p-3 mb-3" style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1.5 shrink-0">
            <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background:"#0A1F3E", border:"1px solid rgba(255,255,255,0.1)" }}>
              <img src={QOYOD_LOGO} alt="قيود" className="w-4 h-4 object-contain"/>
            </div>
            <div className="text-[9px]">
              <div className="font-bold text-white leading-none mb-0.5">قيود</div>
              <div className="flex items-center gap-1 text-emerald-400"><span className="w-1 h-1 rounded-full bg-emerald-400 inline-block animate-pulse"/>متصل</div>
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[9px] text-center mb-1" style={{ color:"rgba(148,163,184,0.5)" }}>تزامن تلقائي كل 15 دقيقة</div>
            <div className="relative h-1.5 rounded-full overflow-hidden" style={{ background:"rgba(255,255,255,0.08)" }}>
              <div className="absolute inset-y-0 right-0 rounded-full transition-all duration-150"
                style={{ width:`${progress}%`, background:"linear-gradient(90deg,#1D4ED8,#3B82F6)", boxShadow:"0 0 8px rgba(59,130,246,0.6)" }}/>
            </div>
            <div className="text-[8px] text-center mt-0.5" style={{ color:"rgba(148,163,184,0.4)" }}>{Math.round(progress)}%</div>
          </div>
          <div className="flex items-center gap-1.5 shrink-0">
            <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background:"#004956", border:"1px solid rgba(255,255,255,0.1)" }}>
              <img src={SALLA_LOGO} alt="سلة" className="w-4 h-4 object-contain"/>
            </div>
            <div className="text-[9px]">
              <div className="font-bold text-white leading-none mb-0.5">سلة</div>
              <div className="flex items-center gap-1 text-emerald-400"><span className="w-1 h-1 rounded-full bg-emerald-400 inline-block animate-pulse"/>متصل</div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 lg:grid-cols-6 gap-1.5 mb-3">
        {STATS.map((s,i) => (
          <div key={i} className="rounded-xl p-2 flex flex-col justify-between" style={{ background:s.bg, border:`1px solid ${s.color}22` }}>
            <div className="text-[9px] leading-tight mb-1" style={{ color:"rgba(148,163,184,0.7)" }}>{s.label}</div>
            <div className="font-bold text-sm leading-none mb-1" style={{ color:s.color, textShadow:`0 0 10px ${s.color}55` }}>{s.val}</div>
            <div className="flex items-end justify-between">
              <div className="text-[7px]" style={{ color:"rgba(148,163,184,0.45)" }}>{s.sub}</div>
              <Spark points={SPARKLINES[s.spark]} color={s.color}/>
            </div>
          </div>
        ))}
      </div>
      <div className="hidden sm:block rounded-xl overflow-hidden" style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div className="px-3 py-2 border-b text-[11px] font-bold text-white" style={{ borderColor:"rgba(255,255,255,0.06)" }}>سجل التزامن الأخير</div>
        {LOG.map((r,i) => (
          <div key={i} className="flex items-center gap-3 px-3 py-1.5 text-[10px] border-b last:border-0" style={{ borderColor:"rgba(255,255,255,0.04)" }}>
            <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background:r.color }}/>
            <span style={{ color:"rgba(148,163,184,0.5)" }}>{r.time}</span>
            <span className="flex-1 text-slate-300">{r.label}</span>
            <span className={`px-2 py-0.5 rounded-full text-[9px] font-semibold ${r.tag}`}>{r.status}</span>
          </div>
        ))}
      </div>
    </div>
  );

  const MATCH_ROWS = [
    { sku:"P-0021", name:"عطر برايم 100ml", qoyod:48,  salla:48,  status:"مطابق",      color:"#10B981", dot:"bg-emerald-400" },
    { sku:"P-0034", name:"كريم مرطب ليلي", qoyod:32,  salla:30,  status:"فرق بسيط",   color:"#FBBF24", dot:"bg-amber-400" },
    { sku:"P-0055", name:"شامبو ذهبي 250",  qoyod:15,  salla:0,   status:"غير موجود",  color:"#F87171", dot:"bg-red-400" },
    { sku:"P-0068", name:"مسحوق تنظيف 1kg", qoyod:100, salla:100, status:"مطابق",      color:"#10B981", dot:"bg-emerald-400" },
    { sku:"P-0079", name:"زيت أرجان طبيعي", qoyod:22,  salla:18,  status:"فرق بسيط",   color:"#FBBF24", dot:"bg-amber-400" },
  ];
  const ViewMatching = (
    <div className="flex-1 p-3 min-w-0 overflow-hidden">
      <div className="rounded-xl p-3 mb-3 flex items-center justify-between gap-2"
        style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div>
          <div className="text-sm font-bold text-white">مطابقة المنتجات</div>
          <div className="text-[10px]" style={{ color:"rgba(148,163,184,0.5)" }}>215 منتج · 8 غير مطابق</div>
        </div>
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[10px] font-bold text-white"
          style={{ background:"linear-gradient(90deg,#1D4ED8,#3B82F6)" }}>
          <span className="w-1.5 h-1.5 rounded-full bg-white/60 animate-pulse"/>مطابقة تلقائية
        </div>
      </div>
      <div className="flex gap-2 mb-2.5">
        <div className="flex-1 rounded-lg px-3 py-1.5 text-[10px] text-slate-400 flex items-center gap-2"
          style={{ background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.08)" }}>
          <span style={{ color:"rgba(148,163,184,0.4)" }}>🔍</span> بحث بالاسم أو SKU...
        </div>
        <div className="rounded-lg px-3 py-1.5 text-[10px] text-slate-400" style={{ background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.08)" }}>الكل ▾</div>
      </div>
      <div className="rounded-xl overflow-hidden" style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div className="grid text-[9px] font-bold px-3 py-2 border-b" style={{ gridTemplateColumns:"1fr 2fr 1fr 1fr 1.2fr", borderColor:"rgba(255,255,255,0.07)", color:"rgba(148,163,184,0.5)" }}>
          <span>SKU</span><span>المنتج</span><span className="text-center">قيود</span><span className="text-center">سلة</span><span className="text-center">الحالة</span>
        </div>
        {MATCH_ROWS.map((r,i) => (
          <div key={i} className="grid items-center px-3 py-2 text-[9px] border-b last:border-0"
            style={{ gridTemplateColumns:"1fr 2fr 1fr 1fr 1.2fr", borderColor:"rgba(255,255,255,0.04)" }}>
            <span className="font-mono text-slate-400">{r.sku}</span>
            <span className="text-slate-300 truncate">{r.name}</span>
            <span className="text-center font-bold" style={{ color:"#3B82F6" }}>{r.qoyod}</span>
            <span className="text-center font-bold" style={{ color:"#A78BFA" }}>{r.salla}</span>
            <span className="flex items-center justify-center gap-1">
              <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${r.dot}`}/>
              <span style={{ color:r.color }}>{r.status}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );

  const IMPORT_ROWS = [
    { name:"عطر برايم 100ml", sku:"P-0021", qty:48, price:"150.00" },
    { name:"كريم مرطب ليلي",  sku:"P-0034", qty:32, price:"85.00"  },
    { name:"شامبو ذهبي 250",  sku:"P-0055", qty:15, price:"45.50"  },
    { name:"مسحوق تنظيف 1kg", sku:"P-0068", qty:100,price:"22.00"  },
  ];
  const ViewImport = (
    <div className="flex-1 p-3 min-w-0 overflow-hidden">
      <div className="rounded-xl p-3 mb-3 flex items-center justify-between"
        style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div>
          <div className="text-sm font-bold text-white">استيراد Excel</div>
          <div className="text-[10px]" style={{ color:"rgba(148,163,184,0.5)" }}>ارفع ملف المخزون لإنشاء المنتجات تلقائياً</div>
        </div>
      </div>
      <div className="rounded-xl p-5 mb-3 text-center"
        style={{ background:"rgba(59,130,246,0.04)", border:"2px dashed rgba(59,130,246,0.25)" }}>
        <div className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-3"
          style={{ background:"rgba(59,130,246,0.12)", border:"1px solid rgba(59,130,246,0.2)" }}>
          <Upload className="w-6 h-6 text-blue-400"/>
        </div>
        <div className="text-[11px] font-bold text-blue-400 mb-1">اسحب الملف هنا أو انقر للرفع</div>
        <div className="text-[9px]" style={{ color:"rgba(148,163,184,0.5)" }}>.xlsx · .xls · .csv — الحد الأقصى 10MB</div>
        <div className="mt-3 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[10px] font-bold text-white"
          style={{ background:"rgba(37,99,235,0.7)", border:"1px solid rgba(59,130,246,0.4)" }}>اختر ملف</div>
      </div>
      <div className="rounded-xl overflow-hidden" style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div className="px-3 py-2 border-b flex items-center justify-between" style={{ borderColor:"rgba(255,255,255,0.06)" }}>
          <span className="text-[10px] font-bold text-white">معاينة البيانات</span>
          <span className="text-[9px] text-emerald-400">✓ inventory_march.xlsx</span>
        </div>
        <div className="grid text-[9px] font-bold px-3 py-1.5 border-b" style={{ gridTemplateColumns:"2fr 1fr 1fr 1fr", borderColor:"rgba(255,255,255,0.06)", color:"rgba(148,163,184,0.5)" }}>
          <span>اسم المنتج</span><span>SKU</span><span>الكمية</span><span>السعر</span>
        </div>
        {IMPORT_ROWS.map((r,i) => (
          <div key={i} className="grid items-center px-3 py-1.5 text-[9px] border-b last:border-0"
            style={{ gridTemplateColumns:"2fr 1fr 1fr 1fr", borderColor:"rgba(255,255,255,0.04)" }}>
            <span className="text-slate-300 truncate">{r.name}</span>
            <span className="font-mono text-slate-400">{r.sku}</span>
            <span className="font-bold" style={{ color:"#10B981" }}>{r.qty}</span>
            <span className="text-slate-400">{r.price}</span>
          </div>
        ))}
        <div className="px-3 py-2 flex items-center justify-between border-t" style={{ borderColor:"rgba(255,255,255,0.06)" }}>
          <span className="text-[9px]" style={{ color:"rgba(148,163,184,0.4)" }}>4 منتجات جاهزة للاستيراد</span>
          <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[10px] font-bold text-white"
            style={{ background:"linear-gradient(90deg,#1D4ED8,#3B82F6)" }}>
            <span className="w-1 h-1 rounded-full bg-white/60 animate-pulse"/>استيراد الآن
          </div>
        </div>
      </div>
    </div>
  );

  const PRODUCTS = [
    { name:"عطر برايم 100ml", sku:"P-0021", qty:48,  color:"#3B82F6" },
    { name:"كريم مرطب ليلي",  sku:"P-0034", qty:32,  color:"#10B981" },
    { name:"شامبو ذهبي 250",  sku:"P-0055", qty:15,  color:"#FBBF24" },
    { name:"مسحوق تنظيف 1kg", sku:"P-0068", qty:100, color:"#A78BFA" },
    { name:"زيت أرجان طبيعي", sku:"P-0079", qty:22,  color:"#34D399" },
    { name:"مستحضر لوسيون",   sku:"P-0082", qty:5,   color:"#F87171" },
  ];
  const ViewProducts = (
    <div className="flex-1 p-3 min-w-0 overflow-hidden">
      <div className="rounded-xl p-3 mb-3 flex items-center justify-between"
        style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div>
          <div className="text-sm font-bold text-white">المنتجات</div>
          <div className="text-[10px]" style={{ color:"rgba(148,163,184,0.5)" }}>16,279 منتج نشط</div>
        </div>
        <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-[9px] text-slate-400"
          style={{ background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.08)" }}>🔍 بحث...</div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {PRODUCTS.map((p,i) => (
          <div key={i} className="rounded-xl p-2.5" style={{ background:"rgba(255,255,255,0.03)", border:`1px solid ${p.color}18` }}>
            <div className="flex items-center gap-1.5 mb-2">
              <div className="w-6 h-6 rounded-lg flex items-center justify-center text-[8px] font-bold shrink-0"
                style={{ background:`${p.color}20`, color:p.color }}>{p.name[0]}</div>
              <div className="min-w-0">
                <div className="text-[9px] font-semibold text-white truncate leading-none mb-0.5">{p.name}</div>
                <div className="font-mono text-[7px]" style={{ color:"rgba(148,163,184,0.4)" }}>{p.sku}</div>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <div className="text-[8px]" style={{ color:"rgba(148,163,184,0.5)" }}>المخزون</div>
              <div className="text-[11px] font-bold" style={{ color:p.color }}>{p.qty}</div>
            </div>
            <div className="mt-1.5 h-1 rounded-full overflow-hidden" style={{ background:"rgba(255,255,255,0.06)" }}>
              <div className="h-full rounded-full" style={{ width:`${Math.min(p.qty,100)}%`, background:p.color, opacity:0.7 }}/>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const BRANCHES = [
    { name:"الرياض",  city:"الرياض",      units:4521, pct:78, color:"#3B82F6" },
    { name:"جدة",     city:"جدة",          units:3200, pct:52, color:"#10B981" },
    { name:"الدمام",  city:"الدمام",       units:2890, pct:45, color:"#A78BFA" },
    { name:"مكة",     city:"مكة المكرمة", units:1848, pct:30, color:"#FBBF24" },
  ];
  const ViewBranches = (
    <div className="flex-1 p-3 min-w-0 overflow-hidden">
      <div className="rounded-xl p-3 mb-3 flex items-center justify-between"
        style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div>
          <div className="text-sm font-bold text-white">الفروع</div>
          <div className="text-[10px]" style={{ color:"rgba(148,163,184,0.5)" }}>4 فروع نشطة · مخزون موحّد</div>
        </div>
        <div className="flex items-center gap-1 px-2.5 py-1 rounded-full text-[9px] font-bold" style={{ background:"rgba(16,185,129,0.12)", color:"#10B981" }}>
          <span className="w-1 h-1 rounded-full bg-emerald-400 inline-block animate-pulse"/>كل الفروع نشطة
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {BRANCHES.map((b,i) => (
          <div key={i} className="rounded-xl p-3" style={{ background:"rgba(255,255,255,0.03)", border:`1px solid ${b.color}22` }}>
            <div className="flex items-start justify-between mb-2">
              <div>
                <div className="text-[11px] font-bold text-white">{b.name}</div>
                <div className="text-[8px]" style={{ color:"rgba(148,163,184,0.5)" }}>{b.city}</div>
              </div>
              <div className="flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[8px]" style={{ background:"rgba(16,185,129,0.12)", color:"#10B981" }}>
                <span className="w-1 h-1 rounded-full bg-emerald-400 inline-block"/>نشط
              </div>
            </div>
            <div className="text-lg font-bold mb-1.5" style={{ color:b.color, textShadow:`0 0 12px ${b.color}44` }}>{b.units.toLocaleString("en-US")}</div>
            <div className="text-[8px] mb-1" style={{ color:"rgba(148,163,184,0.45)" }}>وحدة في المخزون</div>
            <div className="h-1.5 rounded-full overflow-hidden" style={{ background:"rgba(255,255,255,0.08)" }}>
              <div className="h-full rounded-full transition-all" style={{ width:`${b.pct}%`, background:b.color, boxShadow:`0 0 6px ${b.color}66` }}/>
            </div>
            <div className="text-[8px] mt-0.5 text-left font-mono" style={{ color:b.color }}>{b.pct}%</div>
          </div>
        ))}
      </div>
    </div>
  );

  const FULL_LOG = [
    { time:"اليوم 02:15", op:"مزامنة تلقائية",    items:342, status:"ناجحة",       color:"#10B981", tag:"bg-emerald-500/10 text-emerald-400" },
    { time:"اليوم 01:58", op:"تحديث مخزون يدوي",  items:12,  status:"ناجحة",       color:"#10B981", tag:"bg-emerald-500/10 text-emerald-400" },
    { time:"اليوم 01:23", op:"ربط منتجات جديدة",  items:8,   status:"قيد التنفيذ", color:"#3B82F6", tag:"bg-blue-500/10 text-blue-400" },
    { time:"اليوم 00:47", op:"مزامنة تلقائية",    items:0,   status:"فشل",         color:"#F87171", tag:"bg-red-500/10 text-red-400" },
    { time:"أمس  23:15",  op:"مزامنة تلقائية",    items:290, status:"ناجحة",       color:"#10B981", tag:"bg-emerald-500/10 text-emerald-400" },
  ];
  const ViewSyncLog = (
    <div className="flex-1 p-3 min-w-0 overflow-hidden">
      <div className="rounded-xl p-3 mb-3" style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div className="text-sm font-bold text-white mb-2">سجل التزامن</div>
        <div className="grid grid-cols-3 gap-2">
          {[{label:"إجمالي",val:"32",color:"#3B82F6"},{label:"ناجحة",val:"28",color:"#10B981"},{label:"فشل",val:"3",color:"#F87171"}].map((s,i)=>(
            <div key={i} className="text-center rounded-lg p-2" style={{ background:`${s.color}10`, border:`1px solid ${s.color}22` }}>
              <div className="text-base font-bold" style={{ color:s.color }}>{s.val}</div>
              <div className="text-[8px]" style={{ color:"rgba(148,163,184,0.5)" }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="rounded-xl overflow-hidden" style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div className="px-3 py-2 border-b text-[10px] font-bold text-white" style={{ borderColor:"rgba(255,255,255,0.06)" }}>آخر العمليات</div>
        {FULL_LOG.map((r,i)=>(
          <div key={i} className="flex items-center gap-2.5 px-3 py-2 text-[9px] border-b last:border-0" style={{ borderColor:"rgba(255,255,255,0.04)" }}>
            <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background:r.color }}/>
            <span className="w-20 shrink-0" style={{ color:"rgba(148,163,184,0.45)" }}>{r.time}</span>
            <span className="flex-1 text-slate-300 truncate">{r.op}</span>
            {r.items > 0 && <span className="font-mono text-[8px]" style={{ color:"rgba(148,163,184,0.35)" }}>{r.items} منتج</span>}
            <span className={`px-1.5 py-0.5 rounded-full text-[8px] font-semibold shrink-0 ${r.tag}`}>{r.status}</span>
          </div>
        ))}
      </div>
    </div>
  );

  const ViewSettings = (
    <div className="flex-1 p-3 min-w-0 overflow-hidden">
      <div className="rounded-xl p-3 mb-3" style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div className="text-sm font-bold text-white mb-0.5">الإعدادات</div>
        <div className="text-[10px]" style={{ color:"rgba(148,163,184,0.5)" }}>إعدادات التكاملات وجدول المزامنة</div>
      </div>
      <div className="rounded-xl p-3 mb-2" style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div className="flex items-center gap-2 mb-2">
          <div className="w-6 h-6 rounded-lg flex items-center justify-center" style={{ background:"#0A1F3E" }}>
            <img src={QOYOD_LOGO} alt="قيود" className="w-4 h-4 object-contain"/>
          </div>
          <div className="text-[11px] font-bold text-white">قيود — مفتاح API</div>
          <span className="mr-auto flex items-center gap-1 text-[8px] text-emerald-400"><span className="w-1.5 h-1.5 rounded-full bg-emerald-400 inline-block"/>متصل</span>
        </div>
        <div className="flex gap-2">
          <div className="flex-1 rounded-lg px-3 py-1.5 text-[9px] font-mono tracking-widest"
            style={{ background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.08)", color:"rgba(148,163,184,0.4)" }}>
            ••••••••••••••••••••••••••••
          </div>
          <div className="px-2.5 py-1.5 rounded-lg text-[9px] text-blue-400" style={{ background:"rgba(59,130,246,0.1)", border:"1px solid rgba(59,130,246,0.2)" }}>تحقق</div>
        </div>
      </div>
      <div className="rounded-xl p-3 mb-2" style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div className="flex items-center gap-2 mb-2">
          <div className="w-6 h-6 rounded-lg flex items-center justify-center" style={{ background:"#004956" }}>
            <img src={SALLA_LOGO} alt="سلة" className="w-4 h-4 object-contain"/>
          </div>
          <div className="text-[11px] font-bold text-white">سلة — رابط الويب هوك</div>
        </div>
        <div className="flex gap-2">
          <div className="flex-1 rounded-lg px-3 py-1.5 text-[9px] font-mono"
            style={{ background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.08)", color:"rgba(148,163,184,0.6)" }}>
            getjisr.com/api/salla/webhook
          </div>
          <div className="px-2.5 py-1.5 rounded-lg text-[9px] text-slate-400" style={{ background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.08)" }}>نسخ</div>
        </div>
      </div>
      <div className="rounded-xl p-3" style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)" }}>
        <div className="text-[11px] font-bold text-white mb-2">جدول المزامنة التلقائية</div>
        <div className="flex items-center gap-3">
          <div className="text-[10px]" style={{ color:"rgba(148,163,184,0.6)" }}>تزامن كل</div>
          <div className="rounded-lg px-3 py-1.5 text-[10px] font-bold text-white flex items-center gap-1.5"
            style={{ background:"rgba(37,99,235,0.2)", border:"1px solid rgba(59,130,246,0.3)" }}>15 دقيقة ▾</div>
          <div className="mr-auto px-3 py-1.5 rounded-lg text-[10px] font-bold text-white"
            style={{ background:"linear-gradient(90deg,#1D4ED8,#3B82F6)" }}>حفظ</div>
        </div>
      </div>
    </div>
  );

  const VIEWS = [ViewDashboard, ViewMatching, ViewImport, ViewProducts, ViewBranches, ViewSyncLog, ViewSettings];

  return (
    <div className="w-full rounded-2xl overflow-hidden shadow-[0_32px_80px_-12px_rgba(0,0,0,0.6)] border border-white/10 select-none" data-testid="dashboard-mockup">
      <div className="flex items-center gap-3 px-4 py-2.5 border-b border-white/8" style={{ background:"#0D1117" }}>
        <div className="flex gap-1.5 shrink-0">
          <span className="w-2.5 h-2.5 rounded-full bg-[#FF5F57]"/>
          <span className="w-2.5 h-2.5 rounded-full bg-[#FEBC2E]"/>
          <span className="w-2.5 h-2.5 rounded-full bg-[#28C840]"/>
        </div>
        <div className="flex-1 max-w-xs mx-auto rounded-md px-3 py-0.5 text-[11px] text-slate-400 font-mono text-center border border-white/8 flex items-center justify-center gap-1.5"
          style={{ background:"rgba(255,255,255,0.04)" }}>
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"/>
          getjisr.com/{NAV_PAGES[activeNav]}
        </div>
        <div className="flex gap-1.5 shrink-0 text-slate-600 text-[10px]">
          <div className="w-5 h-5 rounded border border-white/8 flex items-center justify-center" style={{ background:"rgba(255,255,255,0.04)" }}>←</div>
          <div className="w-5 h-5 rounded border border-white/8 flex items-center justify-center" style={{ background:"rgba(255,255,255,0.04)" }}>↻</div>
        </div>
      </div>
      <div className="flex" style={{ background:"linear-gradient(160deg,#0F1729 0%,#111827 50%,#0F1729 100%)", minHeight:380 }}>
        <div className="hidden md:flex flex-col w-44 lg:w-52 shrink-0 py-3 relative"
          style={{ background:"rgba(255,255,255,0.02)", borderLeft:"1px solid rgba(255,255,255,0.06)" }}>
          <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-24 h-24 rounded-full pointer-events-none"
            style={{ background:"radial-gradient(circle,rgba(59,130,246,0.08) 0%,transparent 70%)" }}/>
          <div className="px-3 pb-3 mb-2 border-b border-white/6 flex items-center gap-2">
            {logo_base64
              ? <img src={logo_base64} alt={platformName} className="w-7 h-7 rounded-lg object-contain shrink-0" style={{ boxShadow:"0 0 12px rgba(37,99,235,0.3)" }}/>
              : <JasrMark className="w-7 h-7 shrink-0"/>
            }
            <div>
              <div className="text-white text-xs font-bold">{platformName || "جسر"}</div>
              <div className="text-[9px]" style={{ color:"rgba(148,163,184,0.6)" }}>getjisr.com</div>
            </div>
          </div>
          <div className="flex-1 px-1.5 space-y-0.5">
            {NAV.map((item,i) => {
              const NavIcon = NAV_ICONS[i];
              return (
                <div key={i}
                  onClick={() => handleNavClick(i)}
                  data-testid={`mockup-nav-${i}`}
                  className={`flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-[11px] cursor-pointer transition-all duration-200
                    ${i === activeNav ? "font-semibold text-white shadow-sm" : "text-slate-500 hover:text-slate-300"}`}
                  style={i === activeNav ? { background:"linear-gradient(90deg,rgba(37,99,235,0.3),rgba(37,99,235,0.1))", borderRight:"2px solid #3B82F6" } : {}}>
                  <NavIcon className="w-3.5 h-3.5 shrink-0 transition-all"
                    style={{ color: i === activeNav ? "#3B82F6" : "rgba(100,116,139,0.6)" }}
                    strokeWidth={1.8}
                  />
                  {item}
                </div>
              );
            })}
          </div>
          <div className="mx-2 mt-2 px-2.5 py-2 rounded-xl border border-white/6 flex items-center gap-2"
            style={{ background:"rgba(255,255,255,0.03)" }}>
            <div className="w-6 h-6 rounded-full flex items-center justify-center text-[9px] font-bold text-white shrink-0"
              style={{ background:"linear-gradient(135deg,#3B82F6,#1D4ED8)" }}>م</div>
            <div className="min-w-0">
              <div className="text-white text-[10px] font-medium truncate">صاحب المتجر</div>
              <div className="text-[8px] truncate" style={{ color:"rgba(148,163,184,0.5)" }}>owner@mystore.com</div>
            </div>
          </div>
        </div>
        <div className="flex-1 min-w-0 overflow-hidden transition-opacity duration-200"
          style={{ opacity: animating ? 0 : 1 }}>
          {VIEWS[activeNav]}
        </div>
      </div>
    </div>
  );
}

/* ─── Data ─── */
const UPCOMING = [
  { name: "Foodics",     domain: "foodics.com",    name_ar: "فوديكس"  },
  { name: "Odoo",        domain: "odoo.com",        name_ar: "أودو"    },
  { name: "WooCommerce", domain: "woocommerce.com", name_ar: "ووكومرس" },
  { name: "Shopify",     domain: "shopify.com",     name_ar: "شوبيفاي" },
  { name: "Zid",         domain: "zid.sa",          name_ar: "زد"      },
  { name: "Marn",        domain: "marn.com",        name_ar: "مارن"    },
  { name: "Rewaa",       domain: "rewaatech.com",   name_ar: "رواء"    },
  { name: "ExpandCart",  domain: "expandcart.com",  name_ar: "إكسباند" },
];

const TESTIMONIALS = [
  {
    name: "فهد العتيبي",
    role: "صاحب متجر ستايل هاوس",
    city: "الرياض",
    initials: "فع",
    color: "#3B82F6",
    text: "كنا نضيع 3 ساعات يومياً في تحديث المخزون يدوياً بين قيود وسلة. بعد جسر، يحدث كل شيء تلقائياً وبدون أخطاء. توفير حقيقي في الوقت والجهد.",
  },
  {
    name: "سارة الشمري",
    role: "مديرة متجر لمسة للعطور",
    city: "جدة",
    initials: "سش",
    color: "#10B981",
    text: "الإعداد استغرق أقل من 10 دقائق، والتزامن يعمل بشكل رائع. الدعم الفني متجاوب جداً وسريع. أنصح به بشدة لكل تاجر على سلة.",
  },
  {
    name: "محمد الغامدي",
    role: "صاحب متجر تك بلس",
    city: "الدمام",
    initials: "مغ",
    color: "#A78BFA",
    text: "وفّرنا ما يقارب 80% من وقت إدارة المخزون. لا نقلق أبداً من التضارب بين المنصتين. جسر حل مشكلة كانت تؤرقنا كثيراً.",
  },
];

const PLANS = [
  {
    name: "مجاني",
    price: "0",
    currency: "ريال",
    period: "دائماً",
    desc: "للتجربة والاختبار",
    features: [
      { text: "متجر واحد على سلة", ok: true },
      { text: "حتى 100 منتج", ok: true },
      { text: "مزامنة يدوية", ok: true },
      { text: "دعم المجتمع", ok: true },
      { text: "مزامنة تلقائية", ok: false },
      { text: "فروع متعددة", ok: false },
    ],
    cta: "ابدأ مجاناً",
    highlight: false,
    badge: null,
  },
  {
    name: "احترافي",
    price: "99",
    currency: "ريال",
    period: "شهرياً",
    desc: "للتجار الجادين",
    features: [
      { text: "منتجات غير محدودة", ok: true },
      { text: "مزامنة تلقائية كل 15 دقيقة", ok: true },
      { text: "دعم متعدد الفروع", ok: true },
      { text: "استيراد Excel", ok: true },
      { text: "تقارير ومخططات متقدمة", ok: true },
      { text: "دعم واتساب مباشر", ok: true },
    ],
    cta: "ابدأ مجاناً 14 يوم",
    highlight: true,
    badge: "الأكثر شيوعاً",
  },
  {
    name: "مؤسسي",
    price: null,
    currency: null,
    period: null,
    desc: "للشركات الكبرى",
    features: [
      { text: "كل مميزات الاحترافي", ok: true },
      { text: "فروع غير محدودة", ok: true },
      { text: "API مخصص للتكامل", ok: true },
      { text: "SLA مضمون 99.9%", ok: true },
      { text: "مدير حساب مخصص", ok: true },
      { text: "تدريب وتأهيل الفريق", ok: true },
    ],
    cta: "تحدث مع فريقنا",
    highlight: false,
    badge: null,
  },
];

/* ═══════════════════════════════════════════════════════
   MAIN LANDING PAGE
═══════════════════════════════════════════════════════ */
export default function LandingPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { name: platformName, logo_base64 } = usePlatform();
  const [dark, setDark] = useDarkMode();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [apiPlans, setApiPlans] = useState(null);
  const [apiTestimonials, setApiTestimonials] = useState(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

  useEffect(() => {
    fetch(`${backendUrl}/api/public/pricing`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.plans?.length) setApiPlans(d.plans); })
      .catch(() => {});
    fetch(`${backendUrl}/api/public/testimonials`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.testimonials?.length) setApiTestimonials(d.testimonials); })
      .catch(() => {});
  }, []);

  const activePlans = apiPlans || PLANS;
  const activeTestimonials = apiTestimonials || TESTIMONIALS;

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", h, { passive: true });
    return () => window.removeEventListener("scroll", h);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      const h = () => setMobileMenuOpen(false);
      window.addEventListener("scroll", h, { passive: true, once: true });
    }
  }, [mobileMenuOpen]);

  const [heroRef, heroVis] = useReveal(0.05);
  const [stepsRef, stepsVis] = useReveal(0.1);
  const [featRef, featVis] = useReveal(0.1);
  const [testimRef, testimVis] = useReveal(0.1);
  const [pricingRef, pricingVis] = useReveal(0.08);
  const [ctaRef, ctaVis] = useReveal(0.15);

  const marqueeItems = useMemo(() => [...UPCOMING, ...UPCOMING], []);

  return (
    <div dir="rtl" className="min-h-screen bg-[#F9FAFB] dark:bg-slate-950 text-slate-900 dark:text-white"
      style={{ fontFamily: "'Tajawal', sans-serif" }}>

      <style>{`
        @keyframes marq { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .marquee-track { animation: marq 28s linear infinite; }
        .marquee-track:hover { animation-play-state: paused; }
        @keyframes heroFloat { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-12px); } }
        .hero-float { animation: heroFloat 7s ease-in-out infinite; }
        @keyframes glowOrb { 0%,100% { opacity: 0.5; } 50% { opacity: 0.9; } }
        .glow-orb { animation: glowOrb 4s ease-in-out infinite; }
        @keyframes badgeShine {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        html { scroll-behavior: smooth; }
      `}</style>

      {/* ══════════════ NAVBAR ══════════════ */}
      <header className={`sticky top-0 z-50 transition-all duration-300 ${scrolled
        ? "bg-white/90 dark:bg-slate-950/90 backdrop-blur-xl border-b border-slate-200 dark:border-slate-800 shadow-sm"
        : "bg-transparent"}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            {logo_base64
              ? <img src={logo_base64} alt={platformName} className="w-8 h-8 rounded-lg object-contain" />
              : <JasrMark className="w-8 h-8" />}
            <span className={`text-lg font-bold tracking-tight transition-colors ${scrolled ? 'text-slate-900 dark:text-white' : 'text-white'}`}>{platformName || "جسر"}</span>
          </Link>

          <nav className={`hidden md:flex items-center gap-7 text-sm font-medium transition-colors ${scrolled ? 'text-slate-600 dark:text-slate-400' : 'text-white/75'}`}>
            <a href="#how"          className={`transition-colors ${scrolled ? 'hover:text-slate-900 dark:hover:text-white' : 'hover:text-white'}`}>كيف يعمل</a>
            <a href="#features"     className={`transition-colors ${scrolled ? 'hover:text-slate-900 dark:hover:text-white' : 'hover:text-white'}`}>المميزات</a>
            <a href="#pricing"      className={`transition-colors ${scrolled ? 'hover:text-slate-900 dark:hover:text-white' : 'hover:text-white'}`}>الأسعار</a>
            <a href="#integrations" className={`transition-colors ${scrolled ? 'hover:text-slate-900 dark:hover:text-white' : 'hover:text-white'}`}>التكاملات</a>
          </nav>

          <div className="flex items-center gap-2">
            <button onClick={() => setDark(d => !d)} data-testid="dark-mode-toggle"
              className={`w-9 h-9 rounded-lg flex items-center justify-center transition-colors ${scrolled ? 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800' : 'text-white/60 hover:bg-white/10'}`}>
              {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </button>
            {user ? (
              <button onClick={() => navigate("/dashboard")} data-testid="nav-dashboard"
                className={`hidden sm:block px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${scrolled ? 'text-[#004EEB] hover:bg-[#004EEB]/8' : 'text-white hover:bg-white/10'}`}>
                لوحة التحكم
              </button>
            ) : (
              <>
                <Link to="/login" data-testid="nav-login"
                  className={`hidden sm:block px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${scrolled ? 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800' : 'text-white/80 hover:bg-white/10'}`}>
                  تسجيل الدخول
                </Link>
                <Link to="/register" data-testid="nav-register"
                  className="px-4 py-2 text-sm font-bold bg-[#004EEB] text-white rounded-xl hover:bg-[#003BBB] transition-all hover:shadow-lg hover:shadow-blue-200 dark:hover:shadow-blue-900/40">
                  ابدأ مجاناً
                </Link>
              </>
            )}
            <button onClick={() => setMobileMenuOpen(o => !o)} data-testid="mobile-menu-toggle"
              className={`md:hidden w-9 h-9 rounded-lg flex items-center justify-center transition-colors ${scrolled ? 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800' : 'text-white hover:bg-white/10'}`}>
              {mobileMenuOpen ? <XIcon className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-slate-200 dark:border-slate-800 bg-white/97 dark:bg-slate-950/97 backdrop-blur-xl px-4 py-4 flex flex-col gap-1">
            {[
              { href: "#how",          label: "كيف يعمل" },
              { href: "#features",     label: "المميزات"  },
              { href: "#pricing",      label: "الأسعار"   },
              { href: "#integrations", label: "التكاملات" },
            ].map(({ href, label }) => (
              <a key={href} href={href} onClick={() => setMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors">
                {label}
              </a>
            ))}
            <div className="h-px bg-slate-100 dark:bg-slate-800 my-1" />
            {user ? (
              <button onClick={() => { setMobileMenuOpen(false); navigate("/dashboard"); }}
                className="px-4 py-3 text-base font-bold text-[#004EEB] hover:bg-[#004EEB]/8 rounded-xl transition-colors text-right">
                لوحة التحكم
              </button>
            ) : (
              <Link to="/login" onClick={() => setMobileMenuOpen(false)}
                className="px-4 py-3 text-base font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors">
                تسجيل الدخول
              </Link>
            )}
          </div>
        )}
      </header>

      {/* ══════════════ HERO ══════════════ */}
      <section className="relative overflow-hidden" style={{ background: '#030B1A', minHeight: '92vh' }}>
        {/* Grid overlay */}
        <div className="absolute inset-0 pointer-events-none" style={{
          backgroundImage: `linear-gradient(rgba(0,78,235,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(0,78,235,0.05) 1px, transparent 1px)`,
          backgroundSize: '48px 48px'
        }}/>
        {/* Glow orbs */}
        <div className="absolute top-0 right-0 w-[700px] h-[700px] pointer-events-none glow-orb"
          style={{ background: 'radial-gradient(circle at 70% 30%, rgba(0,78,235,0.18) 0%, transparent 60%)' }}/>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] pointer-events-none"
          style={{ background: 'radial-gradient(circle at 30% 70%, rgba(0,78,235,0.08) 0%, transparent 60%)' }}/>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 pt-16 sm:pt-20 lg:pt-24 pb-12 lg:pb-0">

            {/* ── Text (RTL: right) ── */}
            <div ref={heroRef} className="flex-1 lg:max-w-[520px] text-center lg:text-right">

              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-8 text-xs font-bold tracking-wider transition-all duration-700"
                style={{
                  background: 'rgba(0,78,235,0.15)',
                  border: '1px solid rgba(0,78,235,0.35)',
                  color: '#93C5FD',
                  opacity: heroVis ? 1 : 0,
                  transform: heroVis ? 'none' : 'translateY(16px)',
                }}>
                <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse"/>
                مزامنة · تحليلات · سرعة · SEO
              </div>

              {/* H1 */}
              <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight tracking-tight mb-6 transition-all duration-700"
                style={{ opacity: heroVis ? 1 : 0, transform: heroVis ? 'none' : 'translateY(24px)', transitionDelay: '80ms' }}>
                إدارة متجرك
                <br/>
                <span style={{ color: '#60A5FA' }}>بالكامل.</span>
                <br/>
                <span className="text-white">في مكان واحد.</span>
              </h1>

              <p className="text-base sm:text-lg text-slate-400 leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0 transition-all duration-700"
                style={{ opacity: heroVis ? 1 : 0, transform: heroVis ? 'none' : 'translateY(20px)', transitionDelay: '160ms' }}>
                مزامنة مخزون تلقائية بين قيود وسلة، تحليلات ذكية، تحسين سرعة المتجر وSEO — كل ما تحتاجه لتنمو.
              </p>

              {/* CTAs */}
              <div className="flex items-center justify-center lg:justify-start gap-3 mb-10 transition-all duration-700"
                style={{ opacity: heroVis ? 1 : 0, transform: heroVis ? 'none' : 'translateY(20px)', transitionDelay: '240ms' }}>
                <Link to="/register" data-testid="hero-cta-start"
                  className="flex items-center gap-2 px-6 py-3.5 font-bold text-sm sm:text-base rounded-xl transition-all hover:-translate-y-0.5 hover:shadow-2xl"
                  style={{ background: '#004EEB', color: 'white', boxShadow: '0 4px 20px rgba(0,78,235,0.35)' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#003BBB'}
                  onMouseLeave={e => e.currentTarget.style.background = '#004EEB'}>
                  ابدأ مجاناً <ArrowLeft className="w-4 h-4" />
                </Link>
                <Link to="/login" data-testid="hero-cta-login"
                  className="flex items-center gap-2 px-6 py-3.5 font-semibold text-sm sm:text-base rounded-xl transition-all hover:-translate-y-0.5"
                  style={{ border: '1px solid rgba(255,255,255,0.12)', color: 'rgba(255,255,255,0.8)' }}>
                  تسجيل الدخول
                </Link>
              </div>

              {/* Trust metrics */}
              <div className="flex items-center justify-center lg:justify-start gap-5 flex-wrap transition-all duration-700"
                style={{ opacity: heroVis ? 1 : 0, transitionDelay: '320ms' }}>
                {[
                  { icon: Users, val: "312+",  label: "تاجر نشط",        color: "#60A5FA" },
                  { icon: Shield, val: "99.8%", label: "دقة التزامن",    color: "#34D399" },
                  { icon: Clock,  val: "24/7",  label: "مزامنة مستمرة",  color: "#A78BFA" },
                ].map(({ icon: Icon, val, label, color }) => (
                  <div key={label} className="flex items-center gap-2">
                    <div className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
                      style={{ background: `${color}18`, border: `1px solid ${color}30` }}>
                      <Icon className="w-4 h-4" style={{ color }} strokeWidth={1.5}/>
                    </div>
                    <div>
                      <div className="font-bold text-white text-sm leading-none">{val}</div>
                      <div className="text-xs mt-0.5" style={{ color: 'rgba(148,163,184,0.6)' }}>{label}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ── Mockup (RTL: left) ── */}
            <div className="hidden lg:block w-[640px] xl:w-[700px] shrink-0 hero-float pb-0 relative">
              <div className="absolute -inset-8 pointer-events-none rounded-3xl"
                style={{ background: 'radial-gradient(ellipse at center, rgba(0,78,235,0.12) 0%, transparent 70%)' }}/>
              <DashboardMockup />
            </div>
          </div>
        </div>

        {/* Bottom fade */}
        <div className="absolute bottom-0 left-0 right-0 h-28 pointer-events-none"
          style={{ background: 'linear-gradient(to bottom, transparent, #030B1A)' }}/>
        <div className="h-16 sm:h-24"/>
      </section>

      {/* ══════════════ TRUST STRIP ══════════════ */}
      <section className="bg-white dark:bg-slate-900 border-y border-slate-200 dark:border-slate-800" data-testid="trust-strip">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12">
          <p className="text-xs font-bold tracking-[0.15em] text-slate-400 uppercase shrink-0">متكامل مع</p>
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-[#0A1F3E] flex items-center justify-center shadow-md overflow-hidden">
                <img src={QOYOD_LOGO} alt="قيود" className="w-7 h-7 object-contain"/>
              </div>
              <div>
                <div className="font-bold text-slate-800 dark:text-white text-sm">قيود</div>
                <div className="text-xs text-emerald-600 dark:text-emerald-400 flex items-center gap-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block animate-pulse"/>متكامل الآن
                </div>
              </div>
            </div>
            <div className="w-px h-10 bg-slate-200 dark:bg-slate-700"/>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-[#004956] flex items-center justify-center shadow-md overflow-hidden">
                <img src={SALLA_LOGO} alt="سلة" className="w-7 h-7 object-contain"/>
              </div>
              <div>
                <div className="font-bold text-slate-800 dark:text-white text-sm">سلة</div>
                <div className="text-xs text-emerald-600 dark:text-emerald-400 flex items-center gap-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block animate-pulse"/>متكامل مع سلة
                </div>
              </div>
            </div>
          </div>
          <div className="hidden sm:block h-px sm:h-10 sm:w-px bg-slate-200 dark:bg-slate-700"/>
          <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
            <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0"/>
            <span>تكامل مباشر · إعداد في أقل من 10 دقائق</span>
          </div>
        </div>
      </section>

      {/* ══════════════ STATS ══════════════ */}
      <section className="bg-slate-50 dark:bg-slate-950 border-b border-slate-200 dark:border-slate-800" data-testid="stats-section">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 divide-x divide-x-reverse divide-slate-200 dark:divide-slate-800">
          {[
            { icon: Package,   label: "منتج مُزامَن",    to: 16279, suffix: "+", color: "#3B82F6", bg: "rgba(59,130,246,0.08)"  },
            { icon: Shield,    label: "دقة المزامنة",    to: 99,    suffix: ".8%", color: "#10B981", bg: "rgba(16,185,129,0.08)" },
            { icon: Zap,       label: "توقف في السنة",  to: 0,     suffix: " ساعة", color: "#A78BFA", bg: "rgba(167,139,250,0.08)" },
            { icon: GitBranch, label: "فروع مدعومة",    to: 4,     suffix: "+", color: "#F59E0B", bg: "rgba(245,158,11,0.08)"  },
          ].map(({ icon: Icon, label, to, suffix, color, bg }, i) => (
            <div key={i} className="py-10 sm:py-14 px-6 sm:px-10 text-center">
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{ background: bg }}>
                <Icon className="w-5 h-5" style={{ color }} strokeWidth={1.5}/>
              </div>
              <div className="text-3xl sm:text-4xl font-bold mb-1" style={{ color, fontFamily: "'JetBrains Mono', monospace" }}>
                <Counter to={to} suffix={suffix}/>
              </div>
              <div className="text-xs sm:text-sm text-slate-500 dark:text-slate-400 font-medium">{label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ══════════════ DASHBOARD PREVIEW ══════════════ */}
      <section className="py-20 sm:py-28 bg-white dark:bg-slate-950 overflow-hidden" data-testid="dashboard-preview-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <div className="text-xs font-bold tracking-[0.15em] text-[#004EEB] uppercase mb-3">معاينة النظام</div>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-4">
              لوحة تحكم احترافية
            </h2>
            <p className="text-slate-500 dark:text-slate-400 text-base sm:text-lg max-w-xl mx-auto">
              مركز بيانات متكامل — المخزون والتزامن والتقارير كلها في مكان واحد
            </p>
          </div>
          <DashboardMockup />
          <div className="flex items-center justify-center gap-2 mt-5 text-xs text-slate-400 dark:text-slate-500">
            <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse inline-block"/>
            <span>انقر على أي قسم في القائمة الجانبية لاستعراض النظام</span>
          </div>
        </div>
      </section>

      {/* ══════════════ HOW IT WORKS ══════════════ */}
      <section id="how" className="py-20 sm:py-28 bg-slate-50 dark:bg-slate-900" ref={stepsRef}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-14 transition-all duration-700"
            style={{ opacity: stepsVis ? 1 : 0, transform: stepsVis ? 'none' : 'translateY(20px)' }}>
            <div className="text-xs font-bold tracking-[0.15em] text-[#004EEB] uppercase mb-3">آلية العمل</div>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-4">ثلاث خطوات. لا أكثر.</h2>
            <p className="text-slate-500 dark:text-slate-400 text-base sm:text-lg max-w-xl mx-auto">
              اربط نظاميك مرة واحدة، والباقي يحدث تلقائياً كل 15 دقيقة.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative">
            {/* Connector line desktop */}
            <div className="hidden md:block absolute top-[68px] right-[18%] left-[18%] h-px pointer-events-none"
              style={{ background: 'linear-gradient(90deg, rgba(0,78,235,0.15), rgba(0,78,235,0.4), rgba(0,78,235,0.15))' }}/>

            {[
              {
                num: "01", icon: Database, title: "اربط قيود",
                desc: "أدخل مفتاح API من لوحة قيود. جسر يتصل فوراً ويجلب المخزون من جميع فروعك.",
                color: "#3B82F6", bg: "rgba(59,130,246,0.1)",
              },
              {
                num: "02", icon: ShoppingBag, title: "اربط سلة",
                desc: "اضغط زر الربط، صادق على التطبيق في سلة. رمز الوصول يُخزَّن بأمان تام.",
                color: "#004EEB", bg: "rgba(0,78,235,0.1)",
              },
              {
                num: "03", icon: RefreshCw, title: "مزامنة تلقائية",
                desc: "جسر يجمع مخزون الفروع ويرفع الإجمالي إلى سلة تلقائياً. لا تدخل يدوي.",
                color: "#10B981", bg: "rgba(16,185,129,0.1)",
              },
            ].map((step, i) => (
              <div key={i} className="relative transition-all duration-700"
                style={{ opacity: stepsVis ? 1 : 0, transform: stepsVis ? 'none' : 'translateY(24px)', transitionDelay: `${i * 100}ms` }}>
                <div className="bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-2xl p-8 h-full hover:border-[#004EEB]/30 hover:shadow-xl hover:shadow-blue-50 dark:hover:shadow-blue-900/10 transition-all duration-300 group">
                  {/* Step number */}
                  <div className="text-6xl font-bold mb-5 select-none leading-none"
                    style={{ color: 'rgba(0,78,235,0.08)', fontFamily: "'JetBrains Mono', monospace" }}>
                    {step.num}
                  </div>
                  {/* Icon */}
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300"
                    style={{ background: step.bg }}>
                    <step.icon className="w-5 h-5" style={{ color: step.color }} strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">{step.title}</h3>
                  <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════ FEATURES BENTO ══════════════ */}
      <section id="features" className="py-20 sm:py-28 bg-white dark:bg-slate-950 border-y border-slate-200 dark:border-slate-800" ref={featRef}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="mb-12 transition-all duration-700"
            style={{ opacity: featVis ? 1 : 0, transform: featVis ? 'none' : 'translateY(20px)' }}>
            <div className="text-xs font-bold tracking-[0.15em] text-[#004EEB] uppercase mb-3">المميزات</div>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-3">كل ما تحتاجه، في مكان واحد</h2>
            <p className="text-slate-500 dark:text-slate-400 text-base sm:text-lg max-w-xl">حلول متكاملة مصممة خصيصاً لتجار سلة.</p>
          </div>

          <div className="flex flex-col md:grid md:grid-cols-8 gap-4 sm:gap-5">
            {/* Big blue card — Sync */}
            <div data-testid="feature-card-sync"
              className="md:col-span-5 rounded-2xl p-7 sm:p-9 hover:-translate-y-1 hover:shadow-2xl hover:shadow-blue-400/20 transition-all duration-500 group"
              style={{
                background: 'linear-gradient(135deg, #004EEB 0%, #0038CC 100%)',
                border: '1px solid rgba(0,78,235,0.5)',
                opacity: featVis ? 1 : 0,
                transform: featVis ? 'none' : 'translateY(28px)',
                transitionDelay: '0ms'
              }}>
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-6"
                style={{ background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(8px)' }}>
                <Zap className="w-6 h-6 text-white" strokeWidth={1.5} />
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">مزامنة تلقائية للمخزون</h3>
              <p className="text-blue-100 text-base leading-relaxed mb-6">
                ربط قيود بسلة بنقرة واحدة. المخزون يتزامن تلقائياً عبر جميع الفروع كل 15 دقيقة بدقة 99.8%.
              </p>
              <div className="flex flex-wrap gap-2">
                {["كل 15 دقيقة", "دقة 99.8%", "متعدد الفروع", "مزامنة فورية"].map(t => (
                  <span key={t} className="px-3 py-1.5 rounded-lg text-xs text-white font-semibold"
                    style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.15)' }}>{t}</span>
                ))}
              </div>
            </div>

            {/* Analytics card */}
            <div data-testid="feature-card-analytics"
              className="md:col-span-3 bg-slate-900 dark:bg-[#030B1A] border border-slate-700 dark:border-slate-800 rounded-2xl p-7 hover:-translate-y-1 hover:shadow-xl transition-all duration-500 group"
              style={{ opacity: featVis ? 1 : 0, transform: featVis ? 'none' : 'translateY(28px)', transitionDelay: '80ms' }}>
              <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-5"
                style={{ background: 'rgba(167,139,250,0.15)', border: '1px solid rgba(167,139,250,0.2)' }}>
                <BarChart2 className="w-5 h-5 text-purple-400" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">تحليلات ذكية</h3>
              <p className="text-slate-400 text-sm leading-relaxed">مخططات بيانية لأداء المبيعات والمخزون والتزامن. قرارات مبنية على أرقام حقيقية.</p>
              <div className="mt-5 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-purple-400 animate-pulse"/>
                <span className="text-xs text-purple-400 font-semibold">30+ مخطط تفاعلي</span>
              </div>
            </div>

            {/* Small cards grid */}
            <div className="grid grid-cols-2 md:contents gap-4 sm:gap-5">
              {[
                { icon: Zap,            title: "تحسين سرعة المتجر", desc: "ضغط الصور تلقائياً وتحسين سكريبتات المتجر لسرعة تحميل أعلى.",        delay: 120, span: "md:col-span-3", id: "feature-card-speed", color: "#F59E0B"  },
                { icon: TrendingUp,     title: "تحسين SEO",          desc: "تحليل SEO شامل للمنتجات مع اقتراحات ذكية لتحسين ظهورك في محركات البحث.", delay: 160, span: "md:col-span-3", id: "feature-card-seo",   color: "#10B981"  },
                { icon: FileSpreadsheet,title: "استيراد Excel",       desc: "ارفع ملف الجملة. جسر يُنشئ المنتجات في سلة تلقائياً.",                  delay: 200, span: "md:col-span-2", id: "feature-card-excel", color: "#3B82F6"  },
                { icon: GitBranch,      title: "متعدد الفروع",        desc: "اجمع مخزون الفروع في رقم واحد موحد على سلة.",                           delay: 240, span: "md:col-span-3", id: "feature-card-branch",color: "#34D399"  },
              ].map(({ icon: Icon, title, desc, delay, span, id, color }) => (
                <div key={id} data-testid={id}
                  className={`${span} bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-5 sm:p-7 hover:-translate-y-1 hover:border-[#004EEB]/30 hover:shadow-lg dark:hover:shadow-blue-900/10 transition-all duration-500 group`}
                  style={{ opacity: featVis ? 1 : 0, transform: featVis ? 'none' : 'translateY(28px)', transitionDelay: `${delay}ms` }}>
                  <div className="w-10 sm:w-11 h-10 sm:h-11 rounded-xl flex items-center justify-center mb-4 sm:mb-5 transition-transform group-hover:scale-110"
                    style={{ background: `${color}15` }}>
                    <Icon className="w-5 h-5" style={{ color }} strokeWidth={1.5} />
                  </div>
                  <h3 className="text-sm sm:text-lg font-bold text-slate-900 dark:text-white mb-2">{title}</h3>
                  <p className="text-xs sm:text-sm leading-relaxed text-slate-500 dark:text-slate-400">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════ TESTIMONIALS ══════════════ */}
      <section id="testimonials" className="py-20 sm:py-28 bg-slate-50 dark:bg-slate-900" ref={testimRef}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-14 transition-all duration-700"
            style={{ opacity: testimVis ? 1 : 0, transform: testimVis ? 'none' : 'translateY(20px)' }}>
            <div className="text-xs font-bold tracking-[0.15em] text-[#004EEB] uppercase mb-3">آراء التجار</div>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-4">يثق بنا مئات التجار</h2>
            <p className="text-slate-500 dark:text-slate-400 text-base sm:text-lg max-w-xl mx-auto">
              اقرأ ما يقوله أصحاب المتاجر عن تجربتهم مع جسر
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {activeTestimonials.map((t, i) => (
              <div key={i}
                className="bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-2xl p-7 hover:border-[#004EEB]/30 hover:shadow-xl hover:shadow-blue-50 dark:hover:shadow-blue-900/10 transition-all duration-500 flex flex-col group"
                style={{ opacity: testimVis ? 1 : 0, transform: testimVis ? 'none' : 'translateY(28px)', transitionDelay: `${i * 120}ms` }}
                data-testid={`testimonial-${i}`}>
                {/* Stars */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, si) => (
                    <Star key={si} className="w-4 h-4 fill-amber-400 text-amber-400" strokeWidth={0}/>
                  ))}
                </div>
                {/* Quote */}
                <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed flex-1 mb-6">
                  "{t.text}"
                </p>
                {/* Author */}
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-bold text-sm shrink-0 group-hover:scale-105 transition-transform"
                    style={{ background: `linear-gradient(135deg, ${t.color}, ${t.color}cc)` }}>
                    {t.initials}
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 dark:text-white text-sm">{t.name}</div>
                    <div className="text-slate-500 dark:text-slate-400 text-xs">{t.role} · {t.city}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Summary rating */}
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 p-6 bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-2xl max-w-lg mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold text-slate-900 dark:text-white" style={{ fontFamily: "'JetBrains Mono', monospace" }}>5.0</div>
              <div className="flex items-center gap-0.5 mt-1 justify-center">
                {[...Array(5)].map((_, si) => <Star key={si} className="w-4 h-4 fill-amber-400 text-amber-400" strokeWidth={0}/>)}
              </div>
            </div>
            <div className="w-px h-12 bg-slate-200 dark:bg-slate-700 hidden sm:block"/>
            <div className="text-center sm:text-right">
              <div className="text-slate-800 dark:text-slate-200 font-semibold text-sm">من أصحاب المتاجر</div>
              <div className="text-slate-500 dark:text-slate-400 text-xs mt-0.5">متوسط تقييم 312+ تاجر</div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════ PRICING ══════════════ */}
      <section id="pricing" className="py-20 sm:py-28 bg-white dark:bg-slate-950" ref={pricingRef}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-14 transition-all duration-700"
            style={{ opacity: pricingVis ? 1 : 0, transform: pricingVis ? 'none' : 'translateY(20px)' }}>
            <div className="text-xs font-bold tracking-[0.15em] text-[#004EEB] uppercase mb-3">الأسعار</div>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-4">خطط تناسب جميع المتاجر</h2>
            <p className="text-slate-500 dark:text-slate-400 text-base sm:text-lg">ابدأ مجاناً. لا بطاقة ائتمانية مطلوبة.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
            {activePlans.map((plan, i) => (
              <div key={i}
                className="relative rounded-2xl transition-all duration-700"
                style={{
                  opacity: pricingVis ? 1 : 0,
                  transform: pricingVis
                    ? (plan.highlight ? 'translateY(-8px)' : 'none')
                    : 'translateY(28px)',
                  transitionDelay: `${i * 100}ms`,
                }}
                data-testid={`pricing-plan-${i}`}>

                {plan.highlight && (
                  <div className="absolute -top-4 left-0 right-0 flex justify-center z-10">
                    <span className="px-5 py-1.5 rounded-full text-xs font-bold shadow-lg"
                      style={{ background: '#F59E0B', color: '#78350F' }}>
                      {plan.badge}
                    </span>
                  </div>
                )}

                <div className={`rounded-2xl p-8 h-full ${
                  plan.highlight
                    ? 'text-white shadow-2xl'
                    : 'bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 hover:border-[#004EEB]/30'
                }`}
                  style={plan.highlight ? {
                    background: 'linear-gradient(160deg, #004EEB 0%, #003BBB 100%)',
                    border: '1px solid rgba(0,78,235,0.5)',
                    boxShadow: '0 24px 60px rgba(0,78,235,0.25)'
                  } : {}}>

                  {/* Plan name */}
                  <div className={`text-sm font-bold mb-3 ${plan.highlight ? 'text-blue-200' : 'text-[#004EEB]'}`}>
                    {plan.name}
                  </div>

                  {/* Price */}
                  <div className="mb-1">
                    {plan.price ? (
                      <div className="flex items-end gap-1">
                        <span className={`text-5xl font-bold ${plan.highlight ? 'text-white' : 'text-slate-900 dark:text-white'}`}
                          style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                          {plan.price}
                        </span>
                        {plan.currency && (
                          <span className={`text-lg font-semibold mb-1.5 ${plan.highlight ? 'text-blue-200' : 'text-slate-500 dark:text-slate-400'}`}>
                            {plan.currency}
                          </span>
                        )}
                      </div>
                    ) : (
                      <div className={`text-3xl font-bold ${plan.highlight ? 'text-white' : 'text-slate-900 dark:text-white'}`}>
                        تواصل
                      </div>
                    )}
                  </div>
                  <div className={`text-sm mb-1 ${plan.highlight ? 'text-blue-200' : 'text-slate-500 dark:text-slate-400'}`}>
                    {plan.period || "تسعير مخصص"}
                  </div>
                  <div className={`text-xs mb-7 ${plan.highlight ? 'text-blue-200' : 'text-slate-500 dark:text-slate-400'}`}>
                    {plan.desc}
                  </div>

                  {/* CTA */}
                  <Link to="/register"
                    className={`block w-full text-center py-3.5 rounded-xl font-bold text-sm mb-7 transition-all hover:-translate-y-0.5 ${
                      plan.highlight
                        ? 'bg-white text-[#004EEB] hover:bg-blue-50 shadow-lg shadow-blue-900/20'
                        : 'bg-[#004EEB] text-white hover:bg-[#003BBB] hover:shadow-lg hover:shadow-blue-200 dark:hover:shadow-blue-900/20'
                    }`}>
                    {plan.cta}
                  </Link>

                  {/* Divider */}
                  <div className={`h-px mb-7 ${plan.highlight ? 'bg-white/15' : 'bg-slate-200 dark:bg-slate-700'}`}/>

                  {/* Features */}
                  <div className="space-y-3.5">
                    {plan.features.map((f, fi) => (
                      <div key={fi} className={`flex items-center gap-3 text-sm ${!f.ok ? 'opacity-40' : ''}`}>
                        <div className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${
                          f.ok
                            ? (plan.highlight ? 'bg-white/20' : 'bg-[#004EEB]/10')
                            : 'bg-slate-200 dark:bg-slate-700'
                        }`}>
                          {f.ok
                            ? <Check className={`w-3 h-3 ${plan.highlight ? 'text-white' : 'text-[#004EEB]'}`} strokeWidth={2.5}/>
                            : <XIcon className="w-3 h-3 text-slate-400" strokeWidth={2.5}/>
                          }
                        </div>
                        <span className={plan.highlight ? 'text-blue-100' : 'text-slate-600 dark:text-slate-300'}>{f.text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Note */}
          <p className="text-center text-slate-400 dark:text-slate-500 text-sm mt-8">
            جميع الخطط تشمل SSL مجاناً وعزل تام للبيانات. يمكنك الترقية أو التخفيض في أي وقت.
          </p>
        </div>
      </section>

      {/* ══════════════ INTEGRATIONS ══════════════ */}
      <section id="integrations" className="py-20 sm:py-28 bg-slate-50 dark:bg-slate-900 border-y border-slate-200 dark:border-slate-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <div className="text-xs font-bold tracking-[0.15em] text-[#004EEB] uppercase mb-3">التكاملات</div>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-4">يعمل مع منصاتك المفضلة</h2>
            <p className="text-slate-500 dark:text-slate-400 text-base sm:text-lg">تكامل مباشر بدون إعدادات معقدة</p>
          </div>

          {/* Main integration cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-2xl mx-auto mb-12">
            {[
              { logo: QOYOD_LOGO, logoBg: "bg-[#0A1F3E]", logoSize: "w-12 h-12", name: "قيود", desc: "نظام المحاسبة السعودي — سحب المخزون من جميع الفروع", testid: "integration-qoyod" },
              { logo: SALLA_LOGO, logoBg: "bg-[#004956]",  logoSize: "w-10 h-10", name: "سلة",  desc: "منصة التجارة الإلكترونية — تحديث المخزون تلقائياً",  testid: "integration-salla"  },
            ].map(({ logo, logoBg, logoSize, name, desc, testid }) => (
              <div key={testid} data-testid={testid}
                className="bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-2xl p-7 text-center hover:border-[#004EEB]/30 hover:shadow-xl hover:shadow-blue-50 dark:hover:shadow-blue-900/10 transition-all group">
                <div className={`w-18 h-18 w-[72px] h-[72px] rounded-2xl ${logoBg} flex items-center justify-center mx-auto mb-5 group-hover:scale-105 transition-transform shadow-lg overflow-hidden`}>
                  <img src={logo} alt={name} className={`${logoSize} object-contain`} />
                </div>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">{name}</h3>
                <p className="text-slate-500 dark:text-slate-400 text-sm mb-5">{desc}</p>
                <div className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/20 px-3 py-1.5 rounded-full">
                  <CheckCircle2 className="w-3.5 h-3.5" /> متكامل الآن
                </div>
              </div>
            ))}
          </div>

          {/* Upcoming marquee */}
          <div className="border border-slate-200 dark:border-slate-800 rounded-2xl overflow-hidden bg-white dark:bg-slate-950 py-6">
            <p className="text-center text-xs font-bold tracking-[0.15em] text-slate-400 uppercase mb-5">قادم قريباً</p>
            <div className="overflow-hidden relative">
              <div className="absolute inset-y-0 right-0 w-20 pointer-events-none z-10 bg-gradient-to-l from-white dark:from-slate-950 to-transparent"/>
              <div className="absolute inset-y-0 left-0 w-20 pointer-events-none z-10 bg-gradient-to-r from-white dark:from-slate-950 to-transparent"/>
              <div className="flex gap-6 marquee-track" style={{ width: "max-content" }}>
                {marqueeItems.map((p, i) => (
                  <div key={i} className="flex items-center gap-3 px-4 py-2 border border-slate-200 dark:border-slate-700 rounded-xl bg-slate-50 dark:bg-slate-800 hover:border-[#004EEB]/40 transition-colors shrink-0">
                    <BrandLogo domain={p.domain} name={p.name} size={28} />
                    <div>
                      <div className="text-sm font-semibold text-slate-800 dark:text-slate-200 leading-none mb-0.5">{p.name_ar}</div>
                      <div className="text-[10px] text-slate-400 font-mono">{p.name}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════ CTA ══════════════ */}
      <section ref={ctaRef} className="relative overflow-hidden" style={{ background: '#030B1A' }} data-testid="cta-section">
        <div className="absolute inset-0 pointer-events-none"
          style={{ backgroundImage: "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.04) 1px, transparent 0)", backgroundSize: "40px 40px" }}/>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-80 pointer-events-none"
          style={{ background: 'radial-gradient(circle, rgba(0,78,235,0.18) 0%, transparent 65%)' }}/>
        <div className="absolute bottom-0 right-0 w-72 h-72 pointer-events-none"
          style={{ background: 'radial-gradient(circle, rgba(0,78,235,0.08) 0%, transparent 65%)' }}/>

        <div className="relative z-10 text-center py-20 sm:py-28 px-6 sm:px-8 transition-all duration-700 max-w-4xl mx-auto"
          style={{ opacity: ctaVis ? 1 : 0, transform: ctaVis ? 'none' : 'translateY(28px)' }}>
          <div className="text-xs font-bold tracking-[0.15em] text-blue-400 uppercase mb-5">ابدأ الآن</div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-5 leading-tight">
            جاهز لتوفير<br/>
            <span style={{ color: '#60A5FA' }}>40 ساعة كل شهر؟</span>
          </h2>
          <p className="text-slate-400 text-lg mb-10 max-w-xl mx-auto">
            انضم لمئات المتاجر التي تثق بجسر لإدارة مخزونها تلقائياً بدقة لا تتسامح مع الخطأ.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/register" data-testid="cta-register"
              className="w-full sm:w-auto px-8 py-4 font-bold text-base rounded-xl transition-all hover:-translate-y-0.5 hover:shadow-2xl flex items-center justify-center gap-2"
              style={{ background: '#004EEB', color: 'white', boxShadow: '0 4px 24px rgba(0,78,235,0.35)' }}>
              ابدأ مجاناً الآن <ArrowLeft className="w-4 h-4" />
            </Link>
            <Link to="/login" data-testid="cta-login"
              className="w-full sm:w-auto px-8 py-4 border font-semibold text-base rounded-xl transition-all hover:-translate-y-0.5 text-center"
              style={{ borderColor: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.8)' }}>
              لدي حساب بالفعل
            </Link>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-5 mt-8 text-slate-500 text-xs">
            {["لا حاجة لبطاقة ائتمانية", "إعداد في أقل من 10 دقائق", "دعم فني بالعربي"].map(t => (
              <span key={t} className="flex items-center gap-1.5">
                <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500 shrink-0" />{t}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════ FOOTER ══════════════ */}
      <footer className="border-t" style={{ background: '#030B1A', borderColor: 'rgba(255,255,255,0.06)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-16 pb-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 mb-12">
            {/* Brand */}
            <div className="sm:col-span-2 md:col-span-1">
              <div className="flex items-center gap-2.5 mb-4">
                {logo_base64
                  ? <img src={logo_base64} alt={platformName} className="w-8 h-8 rounded-lg object-contain" />
                  : <JasrMark className="w-8 h-8" />}
                <span className="text-white font-bold text-lg">{platformName || "جسر"}</span>
              </div>
              <p className="text-slate-500 text-sm leading-relaxed mb-5">
                منصة متكاملة لمتجرك على سلة — مزامنة، تحليلات، سرعة، SEO.
              </p>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold"
                style={{ background: 'rgba(16,185,129,0.12)', border: '1px solid rgba(16,185,129,0.2)', color: '#6EE7B7' }}>
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"/>
                متاح الآن على سلة
              </div>
            </div>

            {/* Product links */}
            <div>
              <h4 className="text-white font-bold text-sm mb-5">المنتج</h4>
              <ul className="space-y-3">
                {[
                  { href: "#features",     label: "المميزات"   },
                  { href: "#pricing",      label: "الأسعار"    },
                  { href: "#integrations", label: "التكاملات"  },
                  { href: "#how",          label: "كيف يعمل"   },
                ].map(({ href, label }) => (
                  <li key={label}>
                    <a href={href} className="text-slate-400 hover:text-white text-sm transition-colors">{label}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="text-white font-bold text-sm mb-5">الشركة</h4>
              <ul className="space-y-3">
                <li><span className="text-slate-500 text-sm">من نحن</span></li>
                <li><Link to="/blog" className="text-slate-400 hover:text-white text-sm transition-colors">المدونة</Link></li>
                <li><span className="text-slate-500 text-sm">وظائف</span></li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="text-white font-bold text-sm mb-5">الدعم</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/login" className="text-slate-400 hover:text-white text-sm transition-colors">تسجيل الدخول</Link>
                </li>
                <li>
                  <Link to="/register" className="text-slate-400 hover:text-white text-sm transition-colors">إنشاء حساب</Link>
                </li>
                <li>
                  <Link to="/privacy" className="text-slate-400 hover:text-white text-sm transition-colors">سياسة الخصوصية</Link>
                </li>
                <li>
                  <Link to="/terms" className="text-slate-400 hover:text-white text-sm transition-colors">شروط الاستخدام</Link>
                </li>
                <li>
                  <Link to="/contact" className="text-slate-400 hover:text-white text-sm transition-colors">تواصل معنا</Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t pt-8 flex flex-col sm:flex-row items-center justify-between gap-4"
            style={{ borderColor: 'rgba(255,255,255,0.06)' }}>
            <span className="text-slate-500 text-sm">
              © {new Date().getFullYear()} {platformName || "جسر"}. جميع الحقوق محفوظة.
            </span>
            <div className="flex items-center gap-3 text-slate-500 text-sm">
              <span>getjisr.com</span>
              <span className="w-1 h-1 rounded-full bg-slate-600"/>
              <span>Kingdom of Saudi Arabia</span>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
}
